import { RootState } from "../../../store";
import { BillingStatusProcess } from "../../utils/types/types";

export const billingStatusProcessSelector = (
  state: RootState,
): BillingStatusProcess => {
  return state.common.billingStatusProcess;
};
